import * as Sentry from "@sentry/react";
import { getEnvironment } from "./RuntimeConfig";

export const request = (url:string, options:any) => {
  function handleErrors(response:any) {
      if(response.status === 403 && !options.noRedirect){
        delete localStorage.user;
        delete localStorage.token;
        window.location.href = "/";
      }
      if (!response.ok) {
          return response.text().then((text:any) => {
            response.message = text
            throw response;
          });
      }
      return response;
  }
  const params = new URLSearchParams(window.location.search);
  let token = params.get('studentToken') ? params.get('studentToken') : localStorage.token ? localStorage.token : null;
  if(!options.headers){
    options['headers'] = {
      'Authorization' : "Bearer "+token
    }
  }else if(!options.headers['Authorization']){
    options['headers']['Authorization'] = "Bearer "+token;
  }
  if(options['method'] === 'POST' && !options["file"]){
    options["headers"]["Content-Type"] = "application/json";
  }
  if(options['method'] === 'DELETE' || options['method'] === 'PUT'){
    options["headers"]["Content-Type"] = "application/json";
  }

  return fetch(url, options)
  .then( handleErrors)
  .then( response  => {
    return response
  })
  .then( (response) => {
    return response.json()
      .then((data: unknown) => {
        return { data, status: response.status }
      })
    })
  .catch(
    (error) => {
      const status = typeof error.status === "number" ? error.status : undefined;
      if(!status || status >= 500){
        if(getEnvironment() !== 'dev' && getEnvironment() !== 'development'){
          Sentry.addBreadcrumb({
            category: "http",
            level: "error",
            message: "Frontend request failed",
            data: {
              frontendPath: window.location.pathname,
              requestPath: url.split("?")[0],
              status,
            },
          });
          const exception = error instanceof Error
            ? error
            : new Error(`Frontend request failed${status ? ` with status ${status}` : ""}`);
          Sentry.captureException(exception);
        }
      }
      return { error: error, status };
    }
  )
}
